export enum ExportEnumFileType {
    csv = 'Last ned som CSV',
    sosi = 'Last ned som SOSI',
}
